/**
 * Default exercise library
 * These exercises will be imported on first login
 */

import { EQUIPMENT_TYPES } from './equipment-types.js';

export const defaultExercises = [
  // Chest exercises
  {
    name: 'Bench Press',
    zhName: '臥推',
    equipment_type: EQUIPMENT_TYPES.BARBELL,
    muscleGroup: 'chest',
    description: 'Barbell bench press',
    isCustom: false,
  },
  {
    name: 'Bench Press',
    zhName: '臥推',
    equipment_type: EQUIPMENT_TYPES.DUMBBELL,
    muscleGroup: 'chest',
    description: 'Dumbbell bench press',
    isCustom: false,
  },
  {
    name: 'Incline Bench Press',
    zhName: '上斜臥推',
    equipment_type: EQUIPMENT_TYPES.BARBELL,
    muscleGroup: 'chest',
    description: 'Incline barbell bench press',
    isCustom: false,
  },
  {
    name: 'Incline Bench Press',
    zhName: '上斜臥推',
    equipment_type: EQUIPMENT_TYPES.DUMBBELL,
    muscleGroup: 'chest',
    description: 'Incline dumbbell bench press',
    isCustom: false,
  },
  {
    name: 'Incline Bench Press',
    zhName: '上斜臥推',
    equipment_type: EQUIPMENT_TYPES.SMITH_MACHINE,
    muscleGroup: 'chest',
    description: 'Incline smith machine bench press',
    isCustom: false,
  },
  {
    name: 'Decline Bench Press',
    zhName: '下斜臥推',
    equipment_type: EQUIPMENT_TYPES.BARBELL,
    muscleGroup: 'chest',
    description: 'Decline barbell bench press',
    isCustom: false,
  },
  {
    name: 'Floor Press',
    zhName: '地板臥推',
    equipment_type: EQUIPMENT_TYPES.DUMBBELL,
    muscleGroup: 'chest',
    description: 'Dumbbell floor press',
    isCustom: false,
  },
  {
    name: 'Chest Fly',
    zhName: '飛鳥',
    equipment_type: EQUIPMENT_TYPES.DUMBBELL,
    muscleGroup: 'chest',
    description: 'Dumbbell chest fly',
    isCustom: false,
  },
  {
    name: 'Chest Fly',
    zhName: '飛鳥',
    equipment_type: EQUIPMENT_TYPES.CABLE,
    muscleGroup: 'chest',
    description: 'Cable chest fly',
    isCustom: false,
  },
  {
    name: 'Push Up',
    zhName: '伏地挺身',
    equipment_type: EQUIPMENT_TYPES.BODYWEIGHT,
    muscleGroup: 'chest',
    description: 'Standard push up',
    isCustom: false,
  },

  // Back exercises
  {
    name: 'Deadlift',
    zhName: '硬舉',
    equipment_type: EQUIPMENT_TYPES.BARBELL,
    muscleGroup: 'back',
    description: 'Barbell deadlift',
    isCustom: false,
  },
  {
    name: 'Bent Over Row',
    zhName: '俯身划船',
    equipment_type: EQUIPMENT_TYPES.BARBELL,
    muscleGroup: 'back',
    description: 'Barbell bent over row',
    isCustom: false,
  },
  {
    name: 'Bent Over Row',
    zhName: '俯身划船',
    equipment_type: EQUIPMENT_TYPES.DUMBBELL,
    muscleGroup: 'back',
    description: 'Dumbbell bent over row',
    isCustom: false,
  },
  {
    name: 'Lat Pulldown',
    zhName: '滑輪下拉',
    equipment_type: EQUIPMENT_TYPES.CABLE,
    muscleGroup: 'back',
    description: 'Cable lat pulldown',
    isCustom: false,
  },
  {
    name: 'Lat Pulldown',
    zhName: '滑輪下拉',
    equipment_type: EQUIPMENT_TYPES.BAND,
    muscleGroup: 'back',
    description: 'Band lat pulldown',
    isCustom: false,
  },
  {
    name: 'Seated Cable Row',
    zhName: '坐姿划船',
    equipment_type: EQUIPMENT_TYPES.CABLE,
    muscleGroup: 'back',
    description: 'Seated cable row',
    isCustom: false,
  },
  {
    name: 'Pull Up',
    zhName: '引體向上',
    equipment_type: EQUIPMENT_TYPES.BODYWEIGHT,
    muscleGroup: 'back',
    description: 'Pull up',
    isCustom: false,
  },
  {
    name: 'Chin Up',
    zhName: '反手引體向上',
    equipment_type: EQUIPMENT_TYPES.BODYWEIGHT,
    muscleGroup: 'back',
    description: 'Chin up',
    isCustom: false,
  },

  // Shoulder exercises
  {
    name: 'Overhead Press',
    zhName: '肩推',
    equipment_type: EQUIPMENT_TYPES.BARBELL,
    muscleGroup: 'shoulders',
    description: 'Barbell overhead press',
    isCustom: false,
  },
  {
    name: 'Overhead Press',
    zhName: '肩推',
    equipment_type: EQUIPMENT_TYPES.DUMBBELL,
    muscleGroup: 'shoulders',
    description: 'Dumbbell overhead press',
    isCustom: false,
  },
  {
    name: 'Lateral Raise',
    zhName: '側平舉',
    equipment_type: EQUIPMENT_TYPES.DUMBBELL,
    muscleGroup: 'shoulders',
    description: 'Dumbbell lateral raise',
    isCustom: false,
  },
  {
    name: 'Front Raise',
    zhName: '前平舉',
    equipment_type: EQUIPMENT_TYPES.DUMBBELL,
    muscleGroup: 'shoulders',
    description: 'Dumbbell front raise',
    isCustom: false,
  },
  {
    name: 'Rear Delt Fly',
    zhName: '後三角肌飛鳥',
    equipment_type: EQUIPMENT_TYPES.DUMBBELL,
    muscleGroup: 'shoulders',
    description: 'Dumbbell rear delt fly',
    isCustom: false,
  },
  {
    name: 'Face Pull',
    zhName: '面拉',
    equipment_type: EQUIPMENT_TYPES.CABLE,
    muscleGroup: 'shoulders',
    description: 'Cable face pull',
    isCustom: false,
  },

  // Arms exercises
  {
    name: 'Bicep Curl',
    zhName: '二頭彎舉',
    equipment_type: EQUIPMENT_TYPES.BARBELL,
    muscleGroup: 'arms',
    description: 'Barbell bicep curl',
    isCustom: false,
  },
  {
    name: 'Bicep Curl',
    zhName: '二頭彎舉',
    equipment_type: EQUIPMENT_TYPES.DUMBBELL,
    muscleGroup: 'arms',
    description: 'Dumbbell bicep curl',
    isCustom: false,
  },
  {
    name: 'Hammer Curl',
    zhName: '錘式彎舉',
    equipment_type: EQUIPMENT_TYPES.DUMBBELL,
    muscleGroup: 'arms',
    description: 'Dumbbell hammer curl',
    isCustom: false,
  },
  {
    name: 'Triceps Extension',
    zhName: '三頭伸展',
    equipment_type: EQUIPMENT_TYPES.DUMBBELL,
    muscleGroup: 'arms',
    description: 'Dumbbell triceps extension',
    isCustom: false,
  },
  {
    name: 'Triceps Extension',
    zhName: '三頭伸展',
    equipment_type: EQUIPMENT_TYPES.CABLE,
    muscleGroup: 'arms',
    description: 'Cable triceps extension',
    isCustom: false,
  },
  {
    name: 'Single Arm Tricep Extension',
    zhName: '單臂三頭伸展',
    equipment_type: EQUIPMENT_TYPES.DUMBBELL,
    muscleGroup: 'arms',
    description: 'Single arm dumbbell tricep extension',
    isCustom: false,
  },
  {
    name: 'Skull Crusher',
    zhName: '槓鈴法式推舉',
    equipment_type: EQUIPMENT_TYPES.BARBELL,
    muscleGroup: 'arms',
    description: 'Barbell skull crusher',
    isCustom: false,
  },

  // Legs exercises
  {
    name: 'Squat',
    zhName: '深蹲',
    equipment_type: EQUIPMENT_TYPES.BARBELL,
    muscleGroup: 'legs',
    description: 'Barbell squat',
    isCustom: false,
  },
  {
    name: 'Front Squat',
    zhName: '前蹲',
    equipment_type: EQUIPMENT_TYPES.BARBELL,
    muscleGroup: 'legs',
    description: 'Barbell front squat',
    isCustom: false,
  },
  {
    name: 'Leg Press',
    zhName: '腿推',
    equipment_type: EQUIPMENT_TYPES.MACHINE,
    muscleGroup: 'legs',
    description: 'Leg press machine',
    isCustom: false,
  },
  {
    name: 'Leg Extension',
    zhName: '腿伸展',
    equipment_type: EQUIPMENT_TYPES.MACHINE,
    muscleGroup: 'legs',
    description: 'Leg extension machine',
    isCustom: false,
  },
  {
    name: 'Leg Curl',
    zhName: '腿彎舉',
    equipment_type: EQUIPMENT_TYPES.MACHINE,
    muscleGroup: 'legs',
    description: 'Leg curl machine',
    isCustom: false,
  },
  {
    name: 'Romanian Deadlift',
    zhName: '羅馬尼亞硬舉',
    equipment_type: EQUIPMENT_TYPES.BARBELL,
    muscleGroup: 'legs',
    description: 'Barbell Romanian deadlift',
    isCustom: false,
  },
  {
    name: 'Bulgarian Split Squat',
    zhName: '保加利亞分腿蹲',
    equipment_type: EQUIPMENT_TYPES.DUMBBELL,
    muscleGroup: 'legs',
    description: 'Dumbbell Bulgarian split squat',
    isCustom: false,
  },
  {
    name: 'Lunge',
    zhName: '弓箭步',
    equipment_type: EQUIPMENT_TYPES.DUMBBELL,
    muscleGroup: 'legs',
    description: 'Dumbbell lunge',
    isCustom: false,
  },
  {
    name: 'Calf Raise',
    zhName: '提踵',
    equipment_type: EQUIPMENT_TYPES.MACHINE,
    muscleGroup: 'legs',
    description: 'Calf raise machine',
    isCustom: false,
  },

  // Core exercises
  {
    name: 'Plank',
    zhName: '棒式',
    equipment_type: EQUIPMENT_TYPES.BODYWEIGHT,
    muscleGroup: 'core',
    description: 'Plank hold',
    isCustom: false,
  },
  {
    name: 'Sit Up',
    zhName: '仰臥起坐',
    equipment_type: EQUIPMENT_TYPES.BODYWEIGHT,
    muscleGroup: 'core',
    description: 'Sit up',
    isCustom: false,
  },
  {
    name: 'Crunch',
    zhName: '捲腹',
    equipment_type: EQUIPMENT_TYPES.BODYWEIGHT,
    muscleGroup: 'core',
    description: 'Crunch',
    isCustom: false,
  },
  {
    name: 'Reverse Crunch',
    zhName: '反向捲腹',
    equipment_type: EQUIPMENT_TYPES.BODYWEIGHT,
    muscleGroup: 'core',
    description: 'Reverse crunch',
    isCustom: false,
  },
  {
    name: 'Leg Raise',
    zhName: '舉腿',
    equipment_type: EQUIPMENT_TYPES.BODYWEIGHT,
    muscleGroup: 'core',
    description: 'Leg raise',
    isCustom: false,
  },
  {
    name: 'Russian Twist',
    zhName: '俄羅斯轉體',
    equipment_type: EQUIPMENT_TYPES.BODYWEIGHT,
    muscleGroup: 'core',
    description: 'Russian twist',
    isCustom: false,
  },

  // Cardio
  {
    name: 'Running',
    zhName: '跑步',
    equipment_type: null,
    muscleGroup: 'cardio',
    description: 'Running',
    isCustom: false,
  },
  {
    name: 'Cycling',
    zhName: '騎車',
    equipment_type: null,
    muscleGroup: 'cardio',
    description: 'Cycling',
    isCustom: false,
  },
  {
    name: 'Rowing',
    zhName: '划船機',
    equipment_type: EQUIPMENT_TYPES.MACHINE,
    muscleGroup: 'cardio',
    description: 'Rowing machine',
    isCustom: false,
  },

  // Other
  {
    name: 'Stretching',
    zhName: '伸展',
    equipment_type: null,
    muscleGroup: 'other',
    description: 'Stretching',
    isCustom: false,
  },
];
